<template>
  <div>
    <invoice-attachments-modal
      v-model="modalFileAttachments"
      :attachments="fileAttachments"
      :loading="attachmentsLoading"
      :uploading="attachmentUploading"
      :deleting-id="pendingAction.indexOf('delete-attachment:') === 0 ? pendingAction.slice(18) : ''"
      :reset-key="attachmentUploadResetKey"
      :readonly="!canUploadAttachments"
      :deletable="canDeleteAttachments"
      @view="viewAttachment"
      @download="downloadAttachment"
      @delete="deleteAttachment"
      @upload="uploadAttachment"
      @invalid-files="showOversizedFiles"
    />
    <!-- Modal Attachments-->
    <b-modal
      id="modal-attachments"
      v-model="attachmentModal"
      cancel-variant="outline-secondary"
      hide-footer
      centered
      title="Contract"
    >
        <div>
          <div class="messages">
            <b-form-group
label="Agreement Reference *"
label-for="agreementRef"
>
              <b-form-input
v-model="agreementRef"
placeholder="Agreement Reference"
readonly
/>
            </b-form-group>
             <!-- Customer -->
          <b-form-group
label="Customer *"
label-for="customer"
>
            <b-form-input
v-model="customer"
placeholder="Customer"
readonly
/>
          </b-form-group>

          <!-- Description -->
          <b-form-group
label="Description *"
label-for="description"
>
            <b-form-input
v-model="description"
placeholder="Description"
readonly
/>
          </b-form-group>

          <!-- Start Date -->
          <b-form-group
label="Start Date *"
label-for="startDate"
>
            <b-form-input
v-model="startDate_"
placeholder="Start Date"
readonly
/>
          </b-form-group>

          <!-- End Date -->
          <b-form-group
label="End Date *"
label-for="endDate"
>
            <b-form-input
v-model="endDate_"
placeholder="End Date"
readonly
/>
          </b-form-group>

          <b-form-group
label="Attachments *"
label-for="fileAttachments"
>
            <ul
              v-if="fileAttachments.length > 0"
              :ref="fileAttachments"
              class="list-group"
            >
              <li
                v-for="item in fileAttachments"
                :key="item"
                class="list-group-item"
              >
              <div class="float-left">
                <a
href="#"
@click.prevent="downloadFile(item.relative_path, item.filename)"
>{{ item.filename }}</a>
      </div>
              </li>
            </ul>
            </b-form-group>
            <div v-if="fileAttachments.length == 0">
              No Data
            </div><!-- File Upload Section -->
          </div>
        </div>
    </b-modal>
        <!-- Modal Messages-->
        <b-modal
      id="modal-messages"
      v-model="messageModal"
      cancel-variant="outline-secondary"
      hide-footer
      centered
      title="Messages"
    >
      <b-form>
    <div>
        <div class="messages">
        <div
v-if="messagesLoading"
class="text-center py-2"
role="status"
>
          <b-spinner
small
variant="primary"
/>
          <span class="ml-50">Loading messages...</span>
        </div>
        <ul
v-else-if="messagesList.length>0"
class="list-group"
style="height:300px;width:100%;overflow-y:scroll;"
>
          <input
id="invoiceMessageId"
ref="invoiceMessage"
v-model="invoiceMessageId"
type="hidden"
name="invoiceMessageId"
>
            <li
v-for="item in messagesList"
:key="item"
class="list-group-item"
>
              <div
v-if="userFullName.toString()==item.FullName.toString()"
class="float-right"
>
              <h5>Me</h5>
              <span style="font-size:9px">{{ dateFormat(item.InputTime) }}</span>
              <p>{{ item.invoiceMessage }}</p>
              </div>
              <div
v-if="userFullName.toString()!=item.FullName.toString()"
class="float-left"
>
              <h5>{{ item.FullName }}</h5>
              <span style="font-size:9px">{{ dateFormat(item.InputTime) }}</span>
              <p>{{ item.invoiceMessage }}</p>
              </div>
            </li>
        </ul>
    <div v-else>
      No messages yet
      </div><br>
          <form
v-if="canSendInvoiceMessages"
id="send_message_form"
@submit.prevent="sendMessage"
>
            <b-row>
            <b-col
          cols="11"
          md="9"
          >
            <input
v-model="messageBox"
type="text"
class="form-control"
placeholder="Write your message"
aria-label="Message"
>
            </b-col>
            <b-col
          cols="11"
          md="3"
>
              <b-button
                type="submit"
                variant="primary"
                class="pull-right"
                :disabled="messageSending || !messageBox.trim()"
              >
                <b-spinner
v-if="messageSending"
small
class="mr-50"
/>
                {{ messageSending ? 'Sending...' : 'Send' }}
              </b-button>
            </b-col>
          </b-row>
            </form>
          </div>
        </div>
      </b-form>
    </b-modal>
    <!-- Modal Edit-->
    <b-modal
      id="modal-edit"
      v-model="modalShow"
      centered
      hide-footer
      :no-close-on-backdrop="savingInvoice"
      :no-close-on-esc="savingInvoice"
      title="Edit Form"
    >
      <b-form
        class="auth-login-form mt-2"
        @submit.prevent="editInvoiceProcess"
            >
        <b-form-group>
          <label for="email">Invoice No:</label>
          <input
v-model="InvoiceNumberOld"
type="text"
name="InvoiceNo"
class="form-control"
readonly
>

        </b-form-group>
        <b-form-group>
          <label for="email">Date Pusat:</label>
          <input
v-model="InvoiceID"
type="hidden"
name="InvoiceID"
class="form-control"
>
        <b-form-datepicker
          id="invoice-date"
          v-model="InvoiceDate"
        />
        </b-form-group>
        <b-form-group>
          <label for="no_invoice">Central Invoice Number</label>
          <b-form-input
            v-model="InvoiceNumber"
            type="text"
          placeholder="No Invoice"
          />
        </b-form-group>
        <div class="edit-invoice-actions">
          <b-button
            type="button"
            variant="outline-secondary"
            :disabled="savingInvoice"
            @click="modalShow = false"
          >
            Cancel
          </b-button>
          <b-button
            variant="primary"
            type="submit"
            :disabled="savingInvoice"
          >
            <b-spinner
v-if="savingInvoice"
small
class="mr-50"
/>
            {{ savingInvoice ? 'Saving...' : 'Save Changes' }}
          </b-button>
        </div>
      </b-form>
    </b-modal>
    <b-card
no-body
class="mb-0 invoice-list-card"
>
      <b-tabs lazy>
        <b-tab title="All">
          <invoice-list-toolbar
            control-id="all-invoices"
            :search.sync="searchQuery"
            :start-date.sync="startDateFilter"
            :end-date.sync="endDateFilter"
            :branch.sync="branchFilterAll"
            :missing-files.sync="missingFilesFilter"
            :branches="branches"
            :show-branch="userRole !== 'branch'"
            :per-page.sync="perPage"
            :per-page-options="perPageOptions"
            :direction="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :exporting="isLoadingExport"
            @export="exportData('all', 'csvExportAll')"
          />
          <vue-json-to-csv
            ref="csvExportAll"
            class="hidden"
            :csv-title="`invoice_all_${invoiceType}`"
            :json-data="invoicesAll"
            :labels="labels"
          >
            Download CSV
          </vue-json-to-csv>
          <div class="fixed-height-table">
            <b-table
              ref="refInvoiceListTable"
              class="position-relative btable invoice-table"
              :items="fetchInvoices"
              responsive
              hover
              stacked="md"
              head-variant="light"
              :fields="tableColumns"
              primary-key="id"
              :sort-by.sync="sortBy"
              show-empty
              empty-text="No matching records found"
              :sort-desc.sync="isSortDirDesc"
            >
              <template #table-busy>
                <div
                  class="invoice-loading-state"
                  role="status"
                  aria-live="polite"
                >
                  <div class="invoice-loading-indicator">
                    <b-spinner
                      variant="primary"
                      label="Loading invoices"
                    />
                    <span
                      class="invoice-loading-pulse"
                      aria-hidden="true"
                    />
                  </div>
                  <strong>{{ missingFilesFilter ? 'Checking missing files...' : 'Loading invoices...' }}</strong>
                  <small>{{ missingFilesFilter ? 'Verifying attachment availability in storage.' : 'Retrieving the latest invoice data.' }}</small>
                </div>
              </template>
              <!-- Column: Number -->
              <template #cell(no)="data">
        <div class="text-nowrap">
          <span class="align-text-top text-capitalize">{{ (currentPage - 1) * perPage + data.index + 1 }}</span> <!-- Adding 1 to make it 1-based -->
        </div>
      </template>
              <!-- Column: Customer -->
              <template #cell(customer)="data">
                <div class="text-nowrap">
                  <span class="align-text-top text-capitalize">{{
                    data.item.Customer
                  }}</span>
                </div>
              </template>
              <!-- Column: job_no -->
              <template #cell(job_no)="data">
                <div class="text-nowrap">
                  <span class="align-text-top text-capitalize">{{
                    data.item.JobNo
                  }}</span>
                </div>
              </template>
              <!-- Column: inv_no -->
              <template #cell(inv_no)="data">
                <div class="text-nowrap">
                  <span class="align-text-top text-capitalize">{{
                    data.item.InvoiceNumber
                  }}</span>
                </div>
              </template>
              <!-- Column: inv_date -->
              <template #cell(inv_date)="data">
                {{
                  dateSimple(
                    data.item.InvoiceDate,
                    "YYYY-MM-DD"
                  )
                }}
              </template>
              <!-- Column: no_inv_pusat -->
              <template #cell(no_inv_pusat)="data">
                <b-badge
                  pill
                  :variant="data.item.InvoicePusat ? 'light-success' : 'light-secondary'"
                  class="text-capitalize"
                >
                  {{ data.item.InvoicePusat ? data.item.InvoicePusat: "-" }}
                </b-badge>
              </template>
              <template #cell(supporting_doc)="data">
                <b-badge
                  pill
                  :variant="supportingDocumentVariant(data.item.SupportingDoc)"
                  class="text-capitalize"
                >
                  {{ data.item.SupportingDoc }}
                </b-badge>
                <div
                  v-if="data.item.HasMissingAttachments"
                  class="missing-files-flag"
                  :title="`${data.item.MissingAttachmentCount} attachment file(s) missing from storage`"
                >
                  <feather-icon
                    icon="AlertTriangleIcon"
                    size="12"
                  />
                  <span>Missing files</span>
                  <strong>{{ data.item.MissingAttachmentCount }}</strong>
                </div>
              </template>
              <template #cell(no_inv_pusat_date)="data">
                <b-badge
                  pill
                  :variant="data.item.InvoicePusatDate !== '-' ? 'light-success' : 'light-secondary'"
                  class="text-capitalize"
                >
                  {{ data.item.InvoicePusatDate!="-" ? dateSimple(
                    data.item.InvoicePusatDate,
                    "YYYY-MM-DD"
                  ): "-" }}
                </b-badge>
              </template>
              <template #cell(actions)="data">
                <b-dropdown
                  variant="link"
                  no-caret
                  toggle-class="invoice-action-toggle"
                  :right="!$store.state.appConfig.isRTL"
                >
                  <template #button-content>
                    <feather-icon
                      icon="MoreVerticalIcon"
                      size="16"
                      class="align-middle text-body"
                    />
                    <span class="sr-only">Invoice actions</span>
                  </template>
        <b-dropdown-item
v-if="true"
@click="showDetail( data.item.InvoiceNumber )"
>
          <feather-icon icon="SearchIcon" />
          <span class="align-middle ml-50">View Details</span>
        </b-dropdown-item>

        <b-dropdown-item
v-if="data.item.DownloadInvoice!=''"
@click="downloadInvoice( data.item.InvoiceID )"
>
          <feather-icon icon="DownloadIcon" />
          <span class="align-middle ml-50">Download Invoice</span>
        </b-dropdown-item>

        <b-dropdown-item @click="showAttachments( data.item.InvoiceID )">
          <feather-icon icon="FileIcon" />
          <span class="align-middle ml-50">Attachments</span>
        </b-dropdown-item>

        <b-dropdown-item
          v-if="canUploadAttachments"
          @click="uploadFiles( data.item.InvoiceID )"
        >
          <feather-icon icon="UploadIcon" />
          <span class="align-middle ml-50">Upload Attachment</span>
        </b-dropdown-item>
                <b-dropdown-item
v-if="canEditInvoices"
@click="editInvoice( data.item.InvoiceID, dateSimple(data.item.InvoicePusatDate), data.item.InvoicePusat, dateSimple(data.item.InvoiceDate), data.item.InvoiceNumber )"
>
          <feather-icon icon="EditIcon" />
          <span class="align-middle ml-50">Edit</span>
        </b-dropdown-item>
        <b-dropdown-item
v-if="data.item.invoiceApproved == 'Not Approved' && canApproveInvoices"
:disabled="Boolean(pendingAction)"
@click="confirmInvoice( data.item.InvoiceID )"
>
          <feather-icon icon="CheckIcon" />
          <span class="align-middle ml-50">Confirm</span>
        </b-dropdown-item>
        <b-dropdown-item @click="showMessages( data.item.InvoiceID )">
          <feather-icon icon="MessageCircleIcon" />
          <span class="align-middle ml-50">Messages</span>
        </b-dropdown-item>
        <b-dropdown-item
v-if="canVoidInvoices"
:disabled="Boolean(pendingAction)"
@click="voidInvoice( data.item.InvoiceID )"
>
          <feather-icon icon="TrashIcon" />
          <span class="align-middle ml-50">Void</span>
        </b-dropdown-item>
        <b-dropdown-item @click="showContractAttachments( data.item.Agreement )">
          <feather-icon icon="FileIcon" />
          <span class="align-middle ml-50">Contract Attachments</span>
        </b-dropdown-item>
                </b-dropdown>
              </template>
            </b-table>
          </div>
          <div class="invoice-table-footer mx-2 mb-2">
            <b-row>
              <b-col
                cols="12"
                sm="6"
                class="invoice-table-summary d-flex align-items-center justify-content-center justify-content-sm-start"
              >
                <span
class="text-muted"
>Showing {{ dataMeta.from }} to
                   {{ dataMeta.to }} of
                  {{ dataMeta.of }} entries</span>
                <span class="invoice-table-legend">
                  <feather-icon
                  style="color:#00FF00"
                  icon="CheckCircleIcon"
                /> = Accepted,
                <feather-icon
                  style="color:#036bfc"
                  icon="MessageCircleIcon"
                /> = Message,
                <feather-icon
                icon="FileIcon"
/> = Attachment
                </span>
              </b-col>
              <!-- Pagination -->
              <b-col
                cols="12"
                sm="6"
                class="d-flex align-items-center justify-content-center justify-content-sm-end"
              >
                <b-pagination
                  v-model="currentPage"
                  :total-rows="totalItems"
                  :per-page="perPage"
                  first-number
                  last-number
                  class="mb-0 mt-1 mt-sm-0"
                  prev-class="prev-item"
                  next-class="next-item"
                >
                  <template #prev-text>
                    <feather-icon
icon="ChevronLeftIcon"
size="18"
/>
                  </template>
                  <template #next-text>
                    <feather-icon
icon="ChevronRightIcon"
size="18"
/>
                  </template>
                </b-pagination>
              </b-col>
            </b-row>
          </div>
        </b-tab>
        <b-tab title="Confirmed">
          <invoice-list-toolbar
            control-id="confirmed-invoices"
            :search.sync="searchQueryConfirmed"
            :start-date.sync="startDateFilterConfirmed"
            :end-date.sync="endDateFilterConfirmed"
            :branch.sync="branchFilterConfirmed"
            :missing-files.sync="missingFilesFilterConfirmed"
            :branches="branches"
            :show-branch="userRole !== 'branch'"
            :per-page.sync="perPageConfirmed"
            :per-page-options="perPageOptions"
            :direction="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :exporting="isLoadingExport"
            @export="exportData('confirmed', 'csvExportConfirmed')"
          />
          <vue-json-to-csv
            ref="csvExportConfirmed"
            class="hidden"
            :csv-title="`invoice_confirmed_${invoiceType}`"
            :json-data="invoicesAll"
            :labels="labels"
          >
            Download CSV
          </vue-json-to-csv>
          <div class="fixed-height-table">
            <b-table
              ref="refInvoiceListTableConfirmed"
              class="position-relative btable invoice-table"
              :items="fetchInvoicesConfirmed"
              responsive
              hover
              stacked="md"
              head-variant="light"
              :fields="tableColumnsConfirmed"
              primary-key="id"
              show-empty
              empty-text="No matching records found"
            >
              <template #table-busy>
                <div
                  class="invoice-loading-state"
                  role="status"
                  aria-live="polite"
                >
                  <div class="invoice-loading-indicator">
                    <b-spinner
                      variant="primary"
                      label="Loading invoices"
                    />
                    <span
                      class="invoice-loading-pulse"
                      aria-hidden="true"
                    />
                  </div>
                  <strong>{{ missingFilesFilterConfirmed ? 'Checking missing files...' : 'Loading invoices...' }}</strong>
                  <small>{{ missingFilesFilterConfirmed ? 'Verifying attachment availability in storage.' : 'Retrieving the latest invoice data.' }}</small>
                </div>
              </template>
              <!-- Column: Number -->
              <template #cell(no)="data">
        <div class="text-nowrap">
          <span class="align-text-top text-capitalize">{{ (currentPage - 1) * perPage + data.index + 1 }}</span> <!-- Adding 1 to make it 1-based -->
        </div>
      </template>
              <!-- Column: Customer -->
              <template #cell(customer)="data">
                <div class="text-nowrap">
                  <span class="align-text-top text-capitalize">{{
                    data.item.Customer
                  }}</span>
                </div>
              </template>
              <!-- Column: job_no -->
              <template #cell(job_no)="data">
                <div class="text-nowrap">
                  <span class="align-text-top text-capitalize">{{
                    data.item.JobNo
                  }}</span>
                </div>
              </template>
              <!-- Column: inv_no -->
              <template #cell(inv_no)="data">
                <div class="text-nowrap">
                  <span class="align-text-top text-capitalize">{{
                    data.item.InvoiceNumber
                  }}</span>
                </div>
              </template>
              <!-- Column: inv_date -->
              <template #cell(inv_date)="data">
                {{
                  dateSimple(
                    data.item.InvoiceDate,
                    "YYYY-MM-DD"
                  )
                }}
              </template>
              <!-- Column: no_inv_pusat -->
              <template #cell(no_inv_pusat)="data">
                <b-badge
                  pill
                  :variant="data.item.InvoicePusat ? 'light-success' : 'light-secondary'"
                  class="text-capitalize"
                >
                  {{ data.item.InvoicePusat ? data.item.InvoicePusat: "-" }}
                </b-badge>
              </template>
              <template #cell(supporting_doc)="data">
                <b-badge
                  pill
                  :variant="supportingDocumentVariant(data.item.SupportingDoc)"
                  class="text-capitalize"
                >
                  {{ data.item.SupportingDoc }}
                </b-badge>
                <div
                  v-if="data.item.HasMissingAttachments"
                  class="missing-files-flag"
                  :title="`${data.item.MissingAttachmentCount} attachment file(s) missing from storage`"
                >
                  <feather-icon
                    icon="AlertTriangleIcon"
                    size="12"
                  />
                  <span>Missing files</span>
                  <strong>{{ data.item.MissingAttachmentCount }}</strong>
                </div>
              </template>
              <template #cell(no_inv_pusat_date)="data">
                <b-badge
                  pill
                  :variant="data.item.InvoicePusatDate !== '-' ? 'light-success' : 'light-secondary'"
                  class="text-capitalize"
                >
                  {{ data.item.InvoicePusatDate!="-" ? dateSimple(
                    data.item.InvoicePusatDate,
                    "YYYY-MM-DD"
                  ): "-" }}
                </b-badge>
              </template>
              <template #cell(actions)="data">
                <b-dropdown
                  variant="link"
                  no-caret
                  toggle-class="invoice-action-toggle"
                  :right="!$store.state.appConfig.isRTL"
                >
                  <template #button-content>
                    <feather-icon
                      icon="MoreVerticalIcon"
                      size="16"
                      class="align-middle text-body"
                    />
                    <span class="sr-only">Invoice actions</span>
                  </template>
        <b-dropdown-item
v-if="true"
@click="showDetail( data.item.InvoiceNumber )"
>
          <feather-icon icon="SearchIcon" />
          <span class="align-middle ml-50">View Details</span>
        </b-dropdown-item>

        <b-dropdown-item
v-if="data.item.DownloadInvoice!=''"
@click="downloadInvoice( data.item.InvoiceID )"
>
          <feather-icon icon="DownloadIcon" />
          <span class="align-middle ml-50">Download Invoice</span>
        </b-dropdown-item>

        <b-dropdown-item @click="showAttachments( data.item.InvoiceID )">
          <feather-icon icon="FileIcon" />
          <span class="align-middle ml-50">Attachments</span>
        </b-dropdown-item>

        <b-dropdown-item
          v-if="canUploadAttachments"
          @click="uploadFiles( data.item.InvoiceID )"
        >
          <feather-icon icon="UploadIcon" />
          <span class="align-middle ml-50">Upload Attachment</span>
        </b-dropdown-item>
                <b-dropdown-item
v-if="canEditInvoices"
@click="editInvoice( data.item.InvoiceID, dateSimple(data.item.InvoicePusatDate), data.item.InvoicePusat, dateSimple(data.item.InvoiceDate), data.item.InvoiceNumber )"
>
          <feather-icon icon="EditIcon" />
          <span class="align-middle ml-50">Edit</span>
        </b-dropdown-item>
        <b-dropdown-item
v-if="data.item.invoiceApproved == 'Not Approved' && canApproveInvoices"
:disabled="Boolean(pendingAction)"
@click="confirmInvoice( data.item.InvoiceID )"
>
          <feather-icon icon="CheckIcon" />
          <span class="align-middle ml-50">Confirm</span>
        </b-dropdown-item>
        <b-dropdown-item @click="showMessages( data.item.InvoiceID )">
          <feather-icon icon="MessageCircleIcon" />
          <span class="align-middle ml-50">Messages</span>
        </b-dropdown-item>
        <b-dropdown-item
v-if="canVoidInvoices"
:disabled="Boolean(pendingAction)"
@click="voidInvoice( data.item.InvoiceID )"
>
          <feather-icon icon="TrashIcon" />
          <span class="align-middle ml-50">Void</span>
        </b-dropdown-item>
        <b-dropdown-item @click="showContractAttachments( data.item.Agreement )">
          <feather-icon icon="FileIcon" />
          <span class="align-middle ml-50">Contract Attachments</span>
        </b-dropdown-item>
                </b-dropdown>
              </template>
            </b-table>
          </div>
          <div class="invoice-table-footer mx-2 mb-2">
            <b-row>
              <b-col
                cols="12"
                sm="6"
                class="invoice-table-summary d-flex align-items-center justify-content-center justify-content-sm-start"
              >
                <span
class="text-muted"
>Showing {{ dataMetaConfirmed.from }} to
                  {{ dataMetaConfirmed.to }} of
                  {{ dataMetaConfirmed.of }} entries</span>
                <span class="invoice-table-legend">
                  <feather-icon
                  style="color:#00FF00"
                  icon="CheckCircleIcon"
                /> = Accepted,
                <feather-icon
                  style="color:#036bfc"
                  icon="MessageCircleIcon"
                /> = Message,
                <feather-icon
                icon="FileIcon"
/> = Attachment
                </span>
              </b-col>
              <!-- Pagination -->
              <b-col
                cols="12"
                sm="6"
                class="d-flex align-items-center justify-content-center justify-content-sm-end"
              >
                <b-pagination
                  v-model="currentPageConfirmed"
                  :total-rows="totalItemsConfirmed"
                  :per-page="perPageConfirmed"
                  first-number
                  last-number
                  class="mb-0 mt-1 mt-sm-0"
                  prev-class="prev-item"
                  next-class="next-item"
                >
                  <template #prev-text>
                    <feather-icon
icon="ChevronLeftIcon"
size="18"
/>
                  </template>
                  <template #next-text>
                    <feather-icon
icon="ChevronRightIcon"
size="18"
/>
                  </template>
                </b-pagination>
              </b-col>
            </b-row>
          </div>
        </b-tab>
        <b-tab title="Unconfirmed">
          <invoice-list-toolbar
            control-id="unconfirmed-invoices"
            :search.sync="searchQueryUnconfirmed"
            :start-date.sync="startDateFilterUnconfirmed"
            :end-date.sync="endDateFilterUnconfirmed"
            :branch.sync="branchFilterUnconfirmed"
            :missing-files.sync="missingFilesFilterUnconfirmed"
            :branches="branches"
            :show-branch="userRole !== 'branch'"
            :per-page.sync="perPageUnconfirmed"
            :per-page-options="perPageOptions"
            :direction="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :exporting="isLoadingExport"
            @export="exportData('unconfirmed', 'csvExportUnconfirmed')"
          />
          <vue-json-to-csv
            ref="csvExportUnconfirmed"
            class="hidden"
            :csv-title="`invoice_unconfirmed_${invoiceType}`"
            :json-data="invoicesAll"
            :labels="labels"
          >
            Download CSV
          </vue-json-to-csv>
          <div class="fixed-height-table">
            <b-table
              ref="refInvoiceListTableUnconfirmed"
              class="position-relative btable invoice-table"
              :items="fetchInvoicesUnconfirmed"
              responsive
              hover
              stacked="md"
              head-variant="light"
              :fields="tableColumnsUnconfirmed"
              primary-key="id"
              show-empty
              empty-text="No matching records found"
            >
            <template #table-busy>
              <div
                class="invoice-loading-state"
                role="status"
                aria-live="polite"
              >
                <div class="invoice-loading-indicator">
                  <b-spinner
                    variant="primary"
                    label="Loading invoices"
                  />
                  <span
                    class="invoice-loading-pulse"
                    aria-hidden="true"
                  />
                </div>
                <strong>{{ missingFilesFilterUnconfirmed ? 'Checking missing files...' : 'Loading invoices...' }}</strong>
                <small>{{ missingFilesFilterUnconfirmed ? 'Verifying attachment availability in storage.' : 'Retrieving the latest invoice data.' }}</small>
              </div>
            </template>
            <!-- Column: Number -->
            <template #cell(no)="data">
        <div class="text-nowrap">
          <span class="align-text-top text-capitalize">{{ (currentPage - 1) * perPage + data.index + 1 }}</span> <!-- Adding 1 to make it 1-based -->
        </div>
      </template>
              <!-- Column: Customer -->
              <template #cell(customer)="data">
                <div class="text-nowrap">
                  <span class="align-text-top text-capitalize">{{
                    data.item.Customer
                  }}</span>
                </div>
              </template>
              <!-- Column: job_no -->
              <template #cell(job_no)="data">
                <div class="text-nowrap">
                  <span class="align-text-top text-capitalize">{{
                    data.item.JobNo
                  }}</span>
                </div>
              </template>
              <!-- Column: inv_no -->
              <template #cell(inv_no)="data">
                <div class="text-nowrap">
                  <span class="align-text-top text-capitalize">{{
                    data.item.InvoiceNumber
                  }}</span>
                </div>
              </template>
              <!-- Column: inv_date -->
              <template #cell(inv_date)="data">
                {{
                  dateSimple(
                    data.item.InvoiceDate,
                    "YYYY-MM-DD"
                  )
                }}
              </template>
              <!-- Column: no_inv_pusat -->
              <template #cell(no_inv_pusat)="data">
                <b-badge
                  pill
                  :variant="data.item.InvoicePusat ? 'light-success' : 'light-secondary'"
                  class="text-capitalize"
                >
                  {{ data.item.InvoicePusat ? data.item.InvoicePusat: "-" }}
                </b-badge>
              </template>
              <template #cell(supporting_doc)="data">
                <b-badge
                  pill
                  :variant="supportingDocumentVariant(data.item.SupportingDoc)"
                  class="text-capitalize"
                >
                  {{ data.item.SupportingDoc }}
                </b-badge>
                <div
                  v-if="data.item.HasMissingAttachments"
                  class="missing-files-flag"
                  :title="`${data.item.MissingAttachmentCount} attachment file(s) missing from storage`"
                >
                  <feather-icon
                    icon="AlertTriangleIcon"
                    size="12"
                  />
                  <span>Missing files</span>
                  <strong>{{ data.item.MissingAttachmentCount }}</strong>
                </div>
              </template>
              <template #cell(no_inv_pusat_date)="data">
                <b-badge
                  pill
                  :variant="data.item.InvoicePusatDate !== '-' ? 'light-success' : 'light-secondary'"
                  class="text-capitalize"
                >
                  {{ data.item.InvoicePusatDate!="-" ? dateSimple(
                    data.item.InvoicePusatDate,
                    "YYYY-MM-DD"
                  ): "-" }}
                </b-badge>
              </template>
              <template #cell(actions)="data">
                <b-dropdown
                  variant="link"
                  no-caret
                  toggle-class="invoice-action-toggle"
                  :right="!$store.state.appConfig.isRTL"
                >
                  <template #button-content>
                    <feather-icon
                      icon="MoreVerticalIcon"
                      size="16"
                      class="align-middle text-body"
                    />
                    <span class="sr-only">Invoice actions</span>
                  </template>
        <b-dropdown-item
v-if="true"
@click="showDetail( data.item.InvoiceNumber )"
>
          <feather-icon icon="SearchIcon" />
          <span class="align-middle ml-50">View Details</span>
        </b-dropdown-item>

        <b-dropdown-item
v-if="data.item.DownloadInvoice!=''"
@click="downloadInvoice( data.item.InvoiceID )"
>
          <feather-icon icon="DownloadIcon" />
          <span class="align-middle ml-50">Download Invoice</span>
        </b-dropdown-item>

        <b-dropdown-item @click="showAttachments( data.item.InvoiceID )">
          <feather-icon icon="FileIcon" />
          <span class="align-middle ml-50">Attachments</span>
        </b-dropdown-item>

        <b-dropdown-item
          v-if="canUploadAttachments"
          @click="uploadFiles( data.item.InvoiceID )"
        >
          <feather-icon icon="UploadIcon" />
          <span class="align-middle ml-50">Upload Attachment</span>
        </b-dropdown-item>
                <b-dropdown-item
v-if="canEditInvoices"
@click="editInvoice( data.item.InvoiceID, dateSimple(data.item.InvoicePusatDate), data.item.InvoicePusat, dateSimple(data.item.InvoiceDate), data.item.InvoiceNumber )"
>
          <feather-icon icon="EditIcon" />
          <span class="align-middle ml-50">Edit</span>
        </b-dropdown-item>
        <b-dropdown-item
v-if="data.item.invoiceApproved == 'Not Approved' && canApproveInvoices"
:disabled="Boolean(pendingAction)"
@click="confirmInvoice( data.item.InvoiceID )"
>
          <feather-icon icon="CheckIcon" />
          <span class="align-middle ml-50">Confirm</span>
        </b-dropdown-item>
        <b-dropdown-item @click="showMessages( data.item.InvoiceID )">
          <feather-icon icon="MessageCircleIcon" />
          <span class="align-middle ml-50">Messages</span>
        </b-dropdown-item>
        <b-dropdown-item
v-if="canVoidInvoices"
:disabled="Boolean(pendingAction)"
@click="voidInvoice( data.item.InvoiceID )"
>
          <feather-icon icon="TrashIcon" />
          <span class="align-middle ml-50">Void</span>
        </b-dropdown-item>
        <b-dropdown-item @click="showContractAttachments( data.item.Agreement )">
          <feather-icon icon="FileIcon" />
          <span class="align-middle ml-50">Contract Attachments</span>
        </b-dropdown-item>
                </b-dropdown>
              </template>
            </b-table>
          </div>
          <div class="invoice-table-footer mx-2 mb-2">
            <b-row>
              <b-col
                cols="12"
                sm="6"
                class="invoice-table-summary d-flex align-items-center justify-content-center justify-content-sm-start"
              >
                <span
class="text-muted"
>Showing {{ dataMetaUnconfirmed.from }} to
                  {{ dataMetaUnconfirmed.to }} of
                  {{ dataMetaUnconfirmed.of }} entries</span>
                <span class="invoice-table-legend">
                  <feather-icon
                  style="color:#00FF00"
                  icon="CheckCircleIcon"
                /> = Accepted,
                <feather-icon
                  style="color:#036bfc"
                  icon="MessageCircleIcon"
                /> = Message,
                <feather-icon
                icon="FileIcon"
/> = Attachment
                </span>
              </b-col>
              <!-- Pagination -->
              <b-col
                cols="12"
                sm="6"
                class="d-flex align-items-center justify-content-center justify-content-sm-end"
              >
                <b-pagination
                  v-model="currentPageUnconfirmed"
                  :total-rows="totalItemsUnconfirmed"
                  :per-page="perPageUnconfirmed"
                  first-number
                  last-number
                  class="mb-0 mt-1 mt-sm-0"
                  prev-class="prev-item"
                  next-class="next-item"
                >
                  <template #prev-text>
                    <feather-icon
icon="ChevronLeftIcon"
size="18"
/>
                  </template>
                  <template #next-text>
                    <feather-icon
icon="ChevronRightIcon"
size="18"
/>
                  </template>
                </b-pagination>
              </b-col>
            </b-row>
          </div>
        </b-tab>
        <b-tab title="Empty">
          <invoice-list-toolbar
            control-id="empty-invoices"
            :search.sync="searchQueryEmpty"
            :start-date.sync="startDateFilterEmpty"
            :end-date.sync="endDateFilterEmpty"
            :branch.sync="branchFilterEmpty"
            :missing-files.sync="missingFilesFilterEmpty"
            :branches="branches"
            :show-branch="userRole !== 'branch'"
            :per-page.sync="perPageEmpty"
            :per-page-options="perPageOptions"
            :direction="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :exporting="isLoadingExport"
            @export="exportData('empty', 'csvExportEmpty')"
          />
          <vue-json-to-csv
            ref="csvExportEmpty"
            class="hidden"
            :csv-title="`invoice_empty_${invoiceType}`"
            :json-data="invoicesAll"
            :labels="labels"
          >
            Download CSV
          </vue-json-to-csv>
          <div class="fixed-height-table">
            <b-table
              ref="refInvoiceListTableEmpty"
              class="position-relative btable invoice-table"
              :items="fetchInvoicesEmpty"
              responsive
              hover
              stacked="md"
              head-variant="light"
              :fields="tableColumnsEmpty"
              primary-key="id"
              show-empty
              empty-text="No matching records found"
            >
              <template #table-busy>
                <div
                  class="invoice-loading-state"
                  role="status"
                  aria-live="polite"
                >
                  <div class="invoice-loading-indicator">
                    <b-spinner
                      variant="primary"
                      label="Loading invoices"
                    />
                    <span
                      class="invoice-loading-pulse"
                      aria-hidden="true"
                    />
                  </div>
                  <strong>{{ missingFilesFilterEmpty ? 'Checking missing files...' : 'Loading invoices...' }}</strong>
                  <small>{{ missingFilesFilterEmpty ? 'Verifying attachment availability in storage.' : 'Retrieving the latest invoice data.' }}</small>
                </div>
              </template>
              <!-- Column: Number -->
              <!-- Column: Number -->
              <template #cell(no)="data">
        <div class="text-nowrap">
          <span class="align-text-top text-capitalize">{{ (currentPage - 1) * perPage + data.index + 1 }}</span> <!-- Adding 1 to make it 1-based -->
        </div>
      </template>
              <!-- Column: Customer -->
              <template #cell(customer)="data">
                <div class="text-nowrap">
                  <span class="align-text-top text-capitalize">{{
                    data.item.Customer
                  }}</span>
                </div>
              </template>
              <!-- Column: job_no -->
              <template #cell(job_no)="data">
                <div class="text-nowrap">
                  <span class="align-text-top text-capitalize">{{
                    data.item.JobNo
                  }}</span>
                </div>
              </template>
              <!-- Column: inv_no -->
              <template #cell(inv_no)="data">
                <div class="text-nowrap">
                  <span class="align-text-top text-capitalize">{{
                    data.item.InvoiceNumber
                  }}</span>
                </div>
              </template>
              <!-- Column: inv_date -->
              <template #cell(inv_date)="data">
                {{
                  dateSimple(
                    data.item.InvoiceDate,
                    "YYYY-MM-DD"
                  )
                }}
              </template>
              <!-- Column: no_inv_pusat -->
              <template #cell(no_inv_pusat)="data">
                <b-badge
                  pill
                  :variant="data.item.InvoicePusat ? 'light-success' : 'light-secondary'"
                  class="text-capitalize"
                >
                  {{ data.item.InvoicePusat ? data.item.InvoicePusat: "-" }}
                </b-badge>
              </template>
              <template #cell(supporting_doc)="data">
                <b-badge
                  pill
                  :variant="supportingDocumentVariant(data.item.SupportingDoc)"
                  class="text-capitalize"
                >
                  {{ data.item.SupportingDoc }}
                </b-badge>
                <div
                  v-if="data.item.HasMissingAttachments"
                  class="missing-files-flag"
                  :title="`${data.item.MissingAttachmentCount} attachment file(s) missing from storage`"
                >
                  <feather-icon
                    icon="AlertTriangleIcon"
                    size="12"
                  />
                  <span>Missing files</span>
                  <strong>{{ data.item.MissingAttachmentCount }}</strong>
                </div>
              </template>
              <template #cell(no_inv_pusat_date)="data">
                <b-badge
                  pill
                  :variant="data.item.InvoicePusatDate !== '-' ? 'light-success' : 'light-secondary'"
                  class="text-capitalize"
                >
                  {{ data.item.InvoicePusatDate!="-" ? dateSimple(
                    data.item.InvoicePusatDate,
                    "YYYY-MM-DD"
                  ) : "-" }}
                </b-badge>
              </template>
              <template #cell(actions)="data">
                <b-dropdown
                  variant="link"
                  no-caret
                  toggle-class="invoice-action-toggle"
                  :right="!$store.state.appConfig.isRTL"
                >
                  <template #button-content>
                    <feather-icon
                      icon="MoreVerticalIcon"
                      size="16"
                      class="align-middle text-body"
                    />
                    <span class="sr-only">Invoice actions</span>
                  </template>
        <b-dropdown-item
v-if="true"
@click="showDetail( data.item.InvoiceNumber )"
>
          <feather-icon icon="SearchIcon" />
          <span class="align-middle ml-50">View Details</span>
        </b-dropdown-item>

        <b-dropdown-item
v-if="data.item.DownloadInvoice!=''"
@click="downloadInvoice( data.item.InvoiceID )"
>
          <feather-icon icon="DownloadIcon" />
          <span class="align-middle ml-50">Download Invoice</span>
        </b-dropdown-item>

        <b-dropdown-item @click="showAttachments( data.item.InvoiceID )">
          <feather-icon icon="FileIcon" />
          <span class="align-middle ml-50">Attachments</span>
        </b-dropdown-item>

        <b-dropdown-item
          v-if="canUploadAttachments"
          @click="uploadFiles( data.item.InvoiceID )"
        >
          <feather-icon icon="UploadIcon" />
          <span class="align-middle ml-50">Upload Attachment</span>
        </b-dropdown-item>
                <b-dropdown-item
v-if="canEditInvoices"
@click="editInvoice( data.item.InvoiceID, dateSimple(data.item.InvoicePusatDate), data.item.InvoicePusat, dateSimple(data.item.InvoiceDate), data.item.InvoiceNumber )"
>
          <feather-icon icon="EditIcon" />
          <span class="align-middle ml-50">Edit</span>
        </b-dropdown-item>
        <b-dropdown-item
v-if="data.item.invoiceApproved == 'Not Approved' && canApproveInvoices"
:disabled="Boolean(pendingAction)"
@click="confirmInvoice( data.item.InvoiceID )"
>
          <feather-icon icon="CheckIcon" />
          <span class="align-middle ml-50">Confirm</span>
        </b-dropdown-item>
        <b-dropdown-item @click="showMessages( data.item.InvoiceID )">
          <feather-icon icon="MessageCircleIcon" />
          <span class="align-middle ml-50">Messages</span>
        </b-dropdown-item>
        <b-dropdown-item
v-if="canVoidInvoices"
:disabled="Boolean(pendingAction)"
@click="voidInvoice( data.item.InvoiceID )"
>
          <feather-icon icon="TrashIcon" />
          <span class="align-middle ml-50">Void</span>
        </b-dropdown-item>
        <b-dropdown-item @click="showContractAttachments( data.item.Agreement )">
          <feather-icon icon="FileIcon" />
          <span class="align-middle ml-50">Contract Attachments</span>
        </b-dropdown-item>
                </b-dropdown>
              </template>
            </b-table>
          </div>
          <div class="invoice-table-footer mx-2 mb-2">
            <b-row>
              <b-col
                cols="12"
                sm="6"
                class="invoice-table-summary d-flex align-items-center justify-content-center justify-content-sm-start"
              >
                <span
class="text-muted"
>Showing {{ dataMetaEmpty.from }} to
                  {{ dataMetaEmpty.to }} of
                  {{ dataMetaEmpty.of }} entries</span>
                <span class="invoice-table-legend">
                  <feather-icon
                  style="color:#00FF00"
                  icon="CheckCircleIcon"
                /> = Accepted,
                <feather-icon
                  style="color:#036bfc"
                  icon="MessageCircleIcon"
                /> = Message,
                <feather-icon
                icon="FileIcon"
/> = Attachment
                </span>
              </b-col>
              <!-- Pagination -->
              <b-col
                cols="12"
                sm="6"
                class="d-flex align-items-center justify-content-center justify-content-sm-end"
              >
                <b-pagination
                  v-model="currentPageEmpty"
                  :total-rows="totalItemsEmpty"
                  :per-page="perPageEmpty"
                  first-number
                  last-number
                  class="mb-0 mt-1 mt-sm-0"
                  prev-class="prev-item"
                  next-class="next-item"
                >
                  <template #prev-text>
                    <feather-icon
icon="ChevronLeftIcon"
size="18"
/>
                  </template>
                  <template #next-text>
                    <feather-icon
icon="ChevronRightIcon"
size="18"
/>
                  </template>
                </b-pagination>
              </b-col>
            </b-row>
          </div>
        </b-tab>
      </b-tabs>
    </b-card>
  </div>
</template>

<script>
import { uploadSuccess, uploadFailed } from '@/libs/upload-alert'
import {
  BCard,
  BRow,
  BCol,
  BForm,
  BFormInput,
  BFormGroup,
  BButton,
  BTable,
  BMedia,
  BAvatar,
  BLink,
  BBadge,
  BDropdown,
  BDropdownItem,
  BPagination,
  BTabs,
  BTab,
  BFormDatepicker,
  BSpinner,
} from "bootstrap-vue"
import axios from "axios"
import VueJsonToCsv from 'vue-json-to-csv'
import store from "@/store"
import moment from "moment"
import { getToken, getUserData } from '@/auth/utils'
import { hasPermission, PERMISSIONS } from '@/auth/permissions'
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue"
import { ref, onUnmounted } from "@vue/composition-api"
import { avatarText } from "@core/utils/filter"
import InvoiceList from "./List"
import InvoiceAttachmentsModal from '../../components/InvoiceAttachmentsModal.vue'
import InvoiceListToolbar from '../../components/InvoiceListToolbar.vue'

// Unchanged imports
const to = ""
const cc = ""
const reason = ""
const materialRequestId = ""
const messagesList = []
const statusItems = []
const items = []
const fileAttachments = []
const userId = getUserData().user_id
const userRole = ""
const file = ''
const uploadInvoiceId = ''
const modalDetailShow = false
const modalMessage = false
const userFullName = getUserData().FullName
const modalUpload = false
const documentsList = []
const branches = []

export default {
  components: {
    InvoiceAttachmentsModal,
    InvoiceListToolbar,
    VueJsonToCsv,
    BFormGroup,
    BTab,
    BTabs,
    BCard,
    BRow,
    BCol,
    BForm,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BFormDatepicker,
    BSpinner,
  },
  props: {
    invoiceType: {
      type: String,
      default: 'internal',
      validator: value => ['internal', 'local', 'corporate'].includes(value),
    },
  },
  data() {
    return {
      customer: '',
      messageBox: '',
      agreementRef: '',
      description: '',
      branches,
      userFullName,
      modalShow: false,
      invoicesAll: [],
      invoicesConfirmed: [],
      invoicesUnconfirmed: [],
      invoicesEmpty: [],
      InvoiceID: '',
      InvoiceDate: '',
      InvoiceNumber: '',
      InvoiceNumberOld: '',
      startDate_: '',
      endDate_: '',
      modalFileAttachments: false,
      attachmentInvoiceId: '',
      attachmentsLoading: false,
      attachmentUploading: false,
      attachmentUploadResetKey: 0,
      currentCode: '',
      modalUploadShow: false,
      messageModal: false,
      uploadInvoiceId,
      fileAttachments,
      attachmentModal: false,
      file,
      modalUpload,
      items,
      statusItems,
      materialRequestId,
      userId,
      messagesList,
      documentsList,
      isLoadingExport: false,
      pendingAction: '',
      savingInvoice: false,
      messageSending: false,
      messagesLoading: false,
      labels: {
        Customer: { title: 'Customer' },
        JobNo: { title: 'Job No' },
        InvoiceNumber: { title: 'Inv No' },
        InvoiceDate: { title: 'Inv Date' },
        Reference: { title: 'Inv Date' },
        Currency: { title: 'Currency' },
        DPP: { title: 'DPP' },
        Tax: { title: 'Tax' },
        GrandTotal: { title: 'GrandTotal' },
        InvoicePusat: { title: 'Central Invoice No.' },
        InvoicePusatDate: { title: 'Central Invoice Date' },
        invoiceApproved: { title: 'Confirmed' },
        SupportingDoc: { title: 'Supporting Doc' },
},
    }
  },
  computed: {
    canEditInvoices() {
      return hasPermission(PERMISSIONS.EDIT_INVOICES)
    },
    canApproveInvoices() {
      return hasPermission(PERMISSIONS.APPROVE_INVOICES)
    },
    canVoidInvoices() {
      return hasPermission(PERMISSIONS.VOID_INVOICES)
    },
    canUploadAttachments() {
      return hasPermission(PERMISSIONS.UPLOAD_ATTACHMENTS)
    },
    canDeleteAttachments() {
      return hasPermission(PERMISSIONS.DELETE_ATTACHMENTS)
    },
    canSendInvoiceMessages() {
      return hasPermission(PERMISSIONS.SEND_INVOICE_MESSAGES)
    },
  },
  mounted() {
    this.userRole = getUserData().UserRoleSystem
    this.getBranches()
    this.$root.$on("refreshTable", text => {
      console.log(text)
      this.$refs.refInvoiceListTable.refresh()
      this.$refs.refInvoiceListTableConfirmed.refresh()
      this.$refs.refInvoiceListTableUnconfirmed.refresh()
    })
  },
  setup(props) {
    const BRANCH_APP_STORE_MODULE_NAME = "app-material-request"
    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(BRANCH_APP_STORE_MODULE_NAME)) {
        store.unregisterModule(BRANCH_APP_STORE_MODULE_NAME)
      }
    })

    const isAddNewInvoiceSidebarActive = ref(false)

    const statusOptions = [
      { label: "Pending", value: "pending" },
      { label: "Active", value: "active" },
      { label: "Inactive", value: "inactive" },
    ]

    const {
      fetchInvoices,
      fetchInvoicesConfirmed,
      fetchInvoicesUnconfirmed,
      fetchInvoicesEmpty,
      tableColumns,
      tableColumnsConfirmed,
      tableColumnsUnconfirmed,
      tableColumnsEmpty,
      perPage,
      currentPage,
      perPageConfirmed,
      currentPageConfirmed,
      dataMetaConfirmed,
      searchQueryConfirmed,
      perPageUnconfirmed,
      currentPageUnconfirmed,
      dataMetaUnconfirmed,
      searchQueryUnconfirmed,
      perPageEmpty,
      currentPageEmpty,
      dataMetaEmpty,
      searchQueryEmpty,
      totalItems,
      totalItemsConfirmed,
      totalItemsUnconfirmed,
      totalItemsEmpty,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refInvoiceListTable,
      refInvoiceListTableConfirmed,
      refInvoiceListTableUnconfirmed,
      refInvoiceListTableEmpty,
      refetchData,
      refetchDataConfirmed,
      refetchDataEmpty,
      resolveInvoiceRoleVariant,
      resolveInvoiceRoleIcon,
      resolveInvoiceStatusVariant,
      roleOptions,
      roleFilter,
      statusFilter,
      startDateFilter,
      endDateFilter,
      startDateFilterConfirmed,
      endDateFilterConfirmed,
      startDateFilterUnconfirmed,
      endDateFilterUnconfirmed,
      startDateFilterEmpty,
      endDateFilterEmpty,
      branchFilterAll,
      branchFilterConfirmed,
      branchFilterUnconfirmed,
      branchFilterEmpty,
      missingFilesFilter,
      missingFilesFilterConfirmed,
      missingFilesFilterUnconfirmed,
      missingFilesFilterEmpty,
    } = InvoiceList(`get${props.invoiceType}`)

    return {
      branchFilterAll,
      branchFilterConfirmed,
      branchFilterUnconfirmed,
      branchFilterEmpty,
      missingFilesFilter,
      missingFilesFilterConfirmed,
      missingFilesFilterUnconfirmed,
      missingFilesFilterEmpty,
      statusOptions,
      to,
      cc,
      reason,
      modalDetailShow,
      modalMessage,
      isAddNewInvoiceSidebarActive,
      userRole,
      fetchInvoices,
      fetchInvoicesConfirmed,
      fetchInvoicesUnconfirmed,
      fetchInvoicesEmpty,
      tableColumns,
      tableColumnsConfirmed,
      tableColumnsUnconfirmed,
      tableColumnsEmpty,
      perPage,
      currentPage,
      totalItems,
      perPageConfirmed,
      currentPageConfirmed,
      dataMetaConfirmed,
      searchQueryConfirmed,
      totalItemsConfirmed,
      perPageUnconfirmed,
      currentPageUnconfirmed,
      dataMetaUnconfirmed,
      searchQueryUnconfirmed,
      totalItemsUnconfirmed,
      totalItemsEmpty,
      perPageEmpty,
      currentPageEmpty,
      dataMetaEmpty,
      searchQueryEmpty,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refInvoiceListTable,
      refInvoiceListTableConfirmed,
      refInvoiceListTableEmpty,
      refInvoiceListTableUnconfirmed,
      refetchData,
      refetchDataConfirmed,
      refetchDataEmpty,
      avatarText,
      resolveInvoiceRoleVariant,
      resolveInvoiceRoleIcon,
      resolveInvoiceStatusVariant,
      roleOptions,
      roleFilter,
      statusFilter,
      startDateFilter,
      endDateFilter,
      startDateFilterConfirmed,
      endDateFilterConfirmed,
      startDateFilterUnconfirmed,
      endDateFilterUnconfirmed,
      startDateFilterEmpty,
      endDateFilterEmpty,
    }
  },
  methods: {
    notify(title, variant = 'success') {
      this.$toast({
        component: ToastificationContent,
        props: {
          title,
          icon: variant === 'success' ? 'CheckIcon' : 'AlertTriangleIcon',
          variant,
        },
      })
    },
    invoiceHeaders() {
      return {
        'Content-Type': 'application/json',
        'X-Token-Access': `Bearer ${getToken()}`,
      }
    },
    refreshInvoiceTables() {
      const refs = [
        'refInvoiceListTable',
        'refInvoiceListTableConfirmed',
        'refInvoiceListTableUnconfirmed',
        'refInvoiceListTableEmpty',
      ]
      refs.forEach(refName => {
        if (this.$refs[refName]) this.$refs[refName].refresh()
      })
    },
    actionKey(action, invoiceId) {
      return `${action}:${invoiceId}`
    },
    isActionPending(action, invoiceId) {
      return this.pendingAction === this.actionKey(action, invoiceId)
    },
    supportingDocumentVariant(value) {
      const emptyValues = [null, undefined, '', 0, '0', 'No', '-']
      return emptyValues.includes(value) ? 'light-secondary' : 'light-primary'
    },
      getBranches() {
      const userToken = getToken()
        const header = {
          'Content-Type': 'application/json',
          'X-Token-Access': `Bearer ${userToken}`,
        }
          axios
              .get(process.env.VUE_APP_API_GET_BRANCH, { headers: header })
              .then(response => {
                const branchesJoin = response.data.Payload.map(elem => {
                  return { label: `${elem.Deskripsi} (${elem.KodeUnitKerja})`, value: elem.KodeUnitKerja }
                })
                this.branches = branchesJoin.sort((a, b) => parseInt(a.value) > parseInt(b.value) ? 1 : -1)
              })
              .catch(err => {
                  console.log(err)
              })
      },
    async voidInvoice(invoiceId) {
      const key = this.actionKey('void', invoiceId)
      if (this.pendingAction) return
      const confirmed = await this.$bvModal.msgBoxConfirm(
        'This removes the invoice from active records. This action cannot be undone from this screen.',
        {
          title: 'Void this invoice?',
          okTitle: 'Void Invoice',
          okVariant: 'danger',
          cancelTitle: 'Keep Invoice',
          cancelVariant: 'outline-secondary',
          centered: true,
        },
      )
      if (!confirmed) return
      this.pendingAction = key
      try {
        const response = await axios.post(
          'https://api.geolims.com/invoice_service/voidinvoice',
          { InvoiceID: invoiceId },
          { headers: this.invoiceHeaders() },
        )
        if (response.data.Status !== 1) throw new Error(response.data.Message)
        this.refreshInvoiceTables()
        this.notify('Invoice voided successfully')
      } catch (error) {
        this.notify('Unable to void the invoice. Please try again.', 'danger')
      } finally {
        this.pendingAction = ''
      }
    },
    async confirmInvoice(invoiceID) {
      const key = this.actionKey('confirm', invoiceID)
      if (this.pendingAction) return
      this.pendingAction = key
      try {
        const response = await axios.post(
          'https://api.geolims.com/invoice_service/ApproveInvoice',
          { InvoiceID: invoiceID },
          { headers: this.invoiceHeaders() },
        )
        if (response.data.Status !== 1) throw new Error(response.data.Message)
        this.refreshInvoiceTables()
        this.notify('Invoice confirmed successfully')
      } catch (error) {
        this.notify('Unable to confirm the invoice. Please try again.', 'danger')
      } finally {
        this.pendingAction = ''
      }
     },
    editInvoice(invoiceID, invoiceDatePusat, invoiceNumberPusat, invoiceDate, invoiceNumber) {
      this.InvoiceID = invoiceID
      const hasCentralDate = invoiceDatePusat && invoiceDatePusat !== '-'
      this.InvoiceDate = hasCentralDate ? invoiceDatePusat : ''
      this.InvoiceNumber = invoiceNumberPusat && invoiceNumberPusat !== '-'
        ? invoiceNumberPusat
        : ''
      this.InvoiceNumberOld = invoiceNumber
      this.modalShow = true
    },
    async editInvoiceProcess() {
      // Central invoice number and date must be entered together, and the
      // number can't be a placeholder like '0' - this is how job
      // 03025.00691 ended up with NoInvoice = '0' but a real date.
      const dateFilled = !!this.InvoiceDate
      const noInvoiceTrimmed = (this.InvoiceNumber || '').toString().trim()
      const noInvoiceFilled = noInvoiceTrimmed !== ''

      if (dateFilled !== noInvoiceFilled) {
        this.notify('Central invoice number and date must be entered together', 'danger')
        return
      }

      if (noInvoiceFilled && (noInvoiceTrimmed === '0' || noInvoiceTrimmed.length < 3)) {
        this.notify('Invalid central invoice number (minimum 3 characters and cannot be "0")', 'danger')
        return
      }

      if (this.savingInvoice) return
      this.savingInvoice = true
      try {
        const response = await axios.post(
          'https://api.geolims.com/invoice_service/saveInvoicePusat',
          {
            InvoiceID: this.InvoiceID,
            Date: this.InvoiceDate,
            NoInvoice: noInvoiceTrimmed,
          },
          { headers: this.invoiceHeaders() },
        )
        if (Number(response.data.Status) !== 1) {
          throw new Error(response.data.Message || 'Unable to save central invoice details')
        }
        this.modalShow = false
        this.refreshInvoiceTables()
        this.notify('Central invoice details saved successfully')
      } catch (error) {
        const message = error.response && error.response.data
          ? error.response.data.Message
          : error.message
        this.notify(message || 'Unable to save central invoice details. Please try again.', 'danger')
      } finally {
        this.savingInvoice = false
      }
    },
    dateFormat(value, format = 'MM/DD/YYYY hh:mm') {
        return moment(String(value)).format(format)
    },
    async showMessages(invoiceID) {
      this.messageModal = true
      this.invoiceMessageId = invoiceID
      this.messagesLoading = true
      try {
        const response = await axios.post(
          'https://api.geolims.com/invoice_service/getMessages',
          { invoiceID },
          { headers: this.invoiceHeaders() },
        )
        if (response.data.Status !== 1) throw new Error(response.data.Message)
        messagesList.splice(0, messagesList.length, ...(response.data.Payload || []))
      } catch (error) {
        this.notify('Unable to load messages. Please try again.', 'danger')
      } finally {
        this.messagesLoading = false
      }
    },
    async sendMessage() {
      const message = (this.messageBox || '').trim()
      if (!message || this.messageSending) return
      this.messageSending = true
      const invoiceID = this.invoiceMessageId
      try {
        const response = await axios.post(
          'https://api.geolims.com/invoice_service/inputMessages',
          { invoiceID, Message: message },
          { headers: this.invoiceHeaders() },
        )
        if (response.data.Status !== 1) throw new Error(response.data.Message)
        this.messageBox = ''
        const messagesResponse = await axios.post(
          'https://api.geolims.com/invoice_service/getMessages',
          { invoiceID },
          { headers: this.invoiceHeaders() },
        )
        if (messagesResponse.data.Status === 1) {
          messagesList.splice(0, messagesList.length, ...(messagesResponse.data.Payload || []))
        }
        this.notify('Message sent successfully')
      } catch (error) {
        this.notify('Unable to send the message. Please try again.', 'danger')
      } finally {
        this.messageSending = false
      }
    },
    async deleteAttachment(attachment) {
      const fileName = this.attachmentName(attachment)
      const confirmed = await this.$bvModal.msgBoxConfirm(
        `Delete “${fileName}”? This action cannot be undone.`,
        {
          title: 'Delete attachment?',
          okTitle: 'Delete Attachment',
          okVariant: 'danger',
          cancelTitle: 'Cancel',
          cancelVariant: 'outline-secondary',
          centered: true,
        },
      )
      if (!confirmed || this.pendingAction) return
      this.pendingAction = this.actionKey('delete-attachment', attachment.InvoiceAttachmentID)
      try {
        const response = await axios.post(
          'https://api.geolims.com/invoice_service/deleteAttachment',
          { InvoiceAttachmentID: attachment.InvoiceAttachmentID },
          { headers: this.invoiceHeaders() },
        )
        if (response.data.Status !== 1) throw new Error(response.data.Message)
        await this.showAttachments(this.attachmentInvoiceId)
        this.notify('Attachment deleted successfully')
      } catch (error) {
        this.notify('Unable to delete the attachment. Please try again.', 'danger')
      } finally {
        this.pendingAction = ''
      }
    },
    showContractAttachments(ContractCode) {
      const userToken = getToken()
        this.currentCode = ContractCode
        const header = {
          'Content-Type': 'multipart/form-dataitem',
          'X-Token-Access': `Bearer ${userToken}`,
        }
        try {
      axios
        .get(`https://api.geolims.com/invoice_service/getContractAttachmentsRef/${ContractCode}`, { headers: header })
        .then(response => {
          if (response.data.Status === 1) {
        fileAttachments.splice(0, fileAttachments.length)
        const agreementRef_ = response.data.Contract[1]
        const customer_ = response.data.Contract[2]
        const description_ = response.data.Contract[3]
        const issuedDate_ = response.data.Contract[4]
        const startDate__ = response.data.Contract[5]
        const endDate__ = response.data.Contract[6]
        this.agreementRef = agreementRef_
        this.customer = customer_
        this.description = description_
        this.issuedDate = issuedDate_
        this.startDate_ = startDate__
        this.endDate_ = endDate__
        if (response.data.Attachments) {
          response.data.Attachments.map(value => {
            fileAttachments.push(value)
            return value.s3_url
          })
          this.attachmentModal = true
        }
          } else {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Contract not found',
              icon: 'AlertTriangleIcon',
              variant: 'danger',
            },
          })
          }
          })
        } catch (error) {
        console.error('Error fetching contract:', error)
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Contract not found',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
      }
      },
    async uploadAttachment(files) {
      if (!files.length || this.attachmentUploading) return
      this.attachmentUploading = true
      const userToken = getToken()
      const header = {
        'Content-Type': 'multipart/form-dataitem',
        'X-Token-Access': `Bearer ${userToken}`,
      }
      const formData = new FormData()
      files.forEach(fileItem => formData.append('file', fileItem, fileItem.name))
      axios
        .post(`${process.env.VUE_APP_API_URL}${process.env.VUE_APP_API_GET_INVOICE}/upload-docs?invoiceid=${this.attachmentInvoiceId}`, formData, { headers: header })
        .then(response => {
          if (response.data.Status === 1) {
            this.attachmentUploadResetKey += 1
            this.showAttachments(this.attachmentInvoiceId)
            uploadSuccess(this, files.length === 1
              ? 'Attachment uploaded successfully'
              : `${files.length} attachments uploaded successfully`)
          } else {
            uploadFailed(this, { response })
          }
        })
        .catch(error => {
          uploadFailed(this, { error })
        })
        .finally(() => {
          this.attachmentUploading = false
        })
    },
    uploadFiles(invoiceID) {
      this.showAttachments(invoiceID)
    },
    showOversizedFiles(files) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: `File too large (max 100MB): ${files.map(item => item.name).join(', ')}`,
          icon: 'AlertTriangleIcon',
          variant: 'danger',
        },
      })
    },
    downloadFile(folderName, fileName) {
const userToken = getToken()
const headers = {
  'Content-Type': 'application/json',
  'X-Token-Access': `Bearer ${userToken}`,
}
        const url = `https://api.geolims.com/asset_service/saved-assets/`
        const FileName = fileName.replace(url, '')
        const ObjectName = `${folderName}`
        const bodyFormData = new FormData()
        bodyFormData.append('ObjectName', ObjectName)
        bodyFormData.append('FileName', FileName)
      axios
        .post(`https://api.geolims.com/asset_service/get_asset`, bodyFormData, { headers })
        .then(response => {
        if (response.data.Status === 1) {
          window.open(response.data.Payload, '_blank')
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Attachment download started',
              icon: 'CheckIcon',
              variant: 'success',
            },
          })
        } else {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Unable to download the attachment. Please try again.',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
        }
        })
        },
    showAttachments(invoiceID) {
      this.attachmentInvoiceId = invoiceID
      this.modalFileAttachments = true
      this.attachmentsLoading = true
      const userToken = getToken()
      const headers = {
        'Content-Type': 'application/json',
        'X-Token-Access': `Bearer ${userToken}`,
      }
      const body = {
        invoiceMasterID: invoiceID,
      }
      return axios
        .post('https://api.geolims.com/invoice_service/getAttachments', body, { headers })
        .then(response => {
          if (response.data.Status !== 1) throw new Error(response.data.Message)
          fileAttachments.splice(0, fileAttachments.length)
          const attachments = response.data.Payload || []
          attachments.forEach(value => fileAttachments.push(value))
        })
        .catch(() => {
          this.notify('Unable to load attachments. Please try again.', 'danger')
        })
        .finally(() => {
          this.attachmentsLoading = false
        })
    },
    downloadInvoice(id) {
      const url = process.env.VUE_APP_PDF_SERVICE_URL
      const header = {
  'auth-username': process.env.VUE_APP_PDF_SERVICE_USERNAME,
  'auth-password': process.env.VUE_APP_PDF_SERVICE_PASSWORD,
}
      const body = {
        id,
      }
    axios
      .post(url, body, { headers: header })
      .then(response => {
        window.open(response.data.data)
})
    },
    exportData(type, csvExportRef) {
      if (this.isLoadingExport) return
      const userToken = getToken()
      const UserRole = getUserData().UserRoleSystem
      let userKodeUnitKerja = UserRole !== 'super-admin' && UserRole !== 'admin' && UserRole !== 'finance' && UserRole !== 'auditor' && UserRole !== 'executive' ? getUserData().KodeUnitKerja : ''
      let dateFilterStart = ''
      let dateFilterEnd = ''
      let missingFilesOnly = false
      if (type === 'all') {
        missingFilesOnly = this.missingFilesFilter
        if (this.branchFilterAll !== "") {
          userKodeUnitKerja = this.branchFilterAll
        }
        if (this.startDateFilter !== "") {
          dateFilterStart = this.startDateFilter
        }
        if (this.endDateFilter !== "") {
          dateFilterEnd = this.endDateFilter
        }
      } else if (type === 'confirmed') {
        missingFilesOnly = this.missingFilesFilterConfirmed
        if (this.branchFilterConfirmed !== "") {
          userKodeUnitKerja = this.branchFilterConfirmed
        }
        if (this.startDateFilterConfirmed !== "") {
          dateFilterStart = this.startDateFilterConfirmed
        }
        if (this.endDateFilterConfirmed !== "") {
          dateFilterEnd = this.endDateFilterConfirmed
        }
      } else if (type === 'unconfirmed') {
        missingFilesOnly = this.missingFilesFilterUnconfirmed
        if (this.branchFilterUnconfirmed !== "") {
          userKodeUnitKerja = this.branchFilterUnconfirmed
        }
        if (this.startDateFilterEmpty !== "") {
          dateFilterStart = this.startDateFilterEmpty
        }
        if (this.endDateFilterUnconfirmed !== "") {
          dateFilterEnd = this.endDateFilterUnconfirmed
        }
      } else if (type === 'empty') {
        missingFilesOnly = this.missingFilesFilterEmpty
        if (this.branchFilterEmpty !== "") {
          userKodeUnitKerja = this.branchFilterEmpty
        }
        if (this.startDateFilterUnconfirmed !== "") {
          dateFilterStart = this.startDateFilterUnconfirmed
        }
        if (this.endDateFilterEmpty !== "") {
          dateFilterEnd = this.endDateFilterEmpty
        }
      }
const headers = {
  "Content-Type": "application/json",
  "X-Token-Access": `Bearer ${userToken}`,
}
      const url = `${process.env.VUE_APP_API_URL}${process.env.VUE_APP_API_GET_INVOICE}/get${this.invoiceType}?unit_kerja=${userKodeUnitKerja}&limit=9999&offset=0&type=${type}&date_start=${dateFilterStart}&date_end=${dateFilterEnd}&attachment_status=1&attachment_health=${missingFilesOnly ? 'missing' : 'all'}`
      this.isLoadingExport = true
      axios.get(url, {
          headers,
      }).then(response => {
        // Populate invoicesAll with the API response data
      this.invoicesAll = response.data.Payload
    this.invoicesAll = this.invoicesAll.map(invoice => ({
      ...invoice,
      InvoiceNumber: `${invoice.InvoiceNumber}   `, // Wrap in double quotes
    }))
      this.notify('CSV export prepared successfully')
      this.$nextTick(() => {
        if (this.$refs[csvExportRef]) {
          this.$refs[csvExportRef].$el.click()
        } else {
          console.error("CSV Export reference not found")
        }
      })
      }).catch(() => {
        this.notify('Unable to export invoices. Please try again.', 'danger')
      }).finally(() => {
        this.isLoadingExport = false
      })
    },
    attachmentName(item) {
      return item.InvoiceAttachment.split('/').pop().replace(/^[0-9a-f]{32}_/i, '')
    },
    async fetchAttachment(item, disposition) {
      if (item && (item.FileMissing === true || item.StorageStatus === 'missing')) {
        throw new Error('Attachment file is missing from storage')
      }
      const userToken = getToken()
      return axios.get(`${process.env.VUE_APP_API_URL}${process.env.VUE_APP_API_GET_INVOICE}/attachment/${item.InvoiceAttachmentID}?disposition=${disposition}`, {
        headers: { 'X-Token-Access': `Bearer ${userToken}` },
        responseType: 'blob',
      })
    },
    async viewAttachment(item) {
      const previewWindow = window.open('', '_blank')
      try {
        const response = await this.fetchAttachment(item, 'inline')
        const responseType = response.headers['content-type']
        const filenameType = this.attachmentMimeType(this.attachmentName(item))
        // Some older S3 objects were saved with a generic or incorrect MIME
        // type. Prefer the filename for formats the browser can preview.
        const mimeType = filenameType !== 'application/octet-stream'
          ? filenameType
          : (responseType || 'application/octet-stream')
        const objectUrl = URL.createObjectURL(new Blob([response.data], {
          type: mimeType,
        }))
        if (previewWindow) previewWindow.location.href = objectUrl
        else window.open(objectUrl, '_blank')
        window.setTimeout(() => URL.revokeObjectURL(objectUrl), 60000)
      } catch (error) {
        if (previewWindow) previewWindow.close()
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Unable to preview attachment',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
      }
    },
    attachmentMimeType(filename) {
      const extension = String(filename || '').split('.').pop().toLowerCase()
      const types = {
        pdf: 'application/pdf',
        jpg: 'image/jpeg',
        jpeg: 'image/jpeg',
        png: 'image/png',
        gif: 'image/gif',
        webp: 'image/webp',
        svg: 'image/svg+xml',
        txt: 'text/plain',
      }
      return types[extension] || 'application/octet-stream'
    },
    async downloadAttachment(item) {
      try {
        const response = await this.fetchAttachment(item, 'attachment')
        const objectUrl = URL.createObjectURL(response.data)
        const link = document.createElement('a')
        link.href = objectUrl
        link.download = this.attachmentName(item)
        document.body.appendChild(link)
        link.click()
        link.remove()
        // Give mobile browsers time to start reading the downloaded blob.
        window.setTimeout(() => URL.revokeObjectURL(objectUrl), 60000)
      } catch (error) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Unable to download attachment',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
      }
    },
    dateSimple(value, format = "YYYY-MM-DD") {
      let dateRet = ""
      if (value !== null) {
        dateRet = moment(String(value)).format(format)
      } else {
        dateRet = null
      }
      return dateRet
    },
    showDetail(item) {
      localStorage.setItem("invdet", item)
      this.$router.push({ name: "apps-invoice-detail" })
    },
    hasPermission(permission) {
      const permissions = "woi"
      return permissions.includes(permission) ? true : false
    },
    cutString(string) {
      const lengthOf = string.length
      return lengthOf > 30 ? `${string.substring(0, 30)} ...` : string
    },
    showDocuments(id) {
      const userToken = getToken()
const headers = {
  "Content-Type": "application/json",
  Authorization: `Bearer ${userToken}`,
}
      this.materialRequestId = id
      this.modalUpload = true
      axios
        .get(
          `${process.env.VUE_APP_API_URL}${process.env.VUE_APP_API_GET_DOCUMENTS}mr/${id}`,
          { headers },
        )
        .then(response => {
          if (response.data.success === true) {
            console.log("Fetching Data")
            if (response.data.data) {
              this.documentsList.splice(0, this.documentsList.length)
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: "Documents loaded successfully",
                  icon: "CheckIcon",
                  variant: "success",
                },
              })
              response.data.data.map(value => {
                this.documentsList.push(value)
              })
            }
          } else {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: "Unable to load documents. Please try again.",
                icon: "AlertTriangleIcon",
                variant: "danger",
              },
            })
          }
        })
    },
    handleFilesUpload(e) {
          const selectedFiles = Array.from(e.target.files || e.dataTransfer.files)
          const maxSize = 100 * 1024 * 1024 // 100MB - must match backend MAX_CONTENT_LENGTH
          const oversized = selectedFiles.filter(f => f.size > maxSize)
          if (oversized.length) {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: `File too large (max 100MB): ${oversized.map(f => f.name).join(', ')}`,
                icon: 'AlertTriangleIcon',
                variant: 'danger',
              },
            })
          }
          this.file = selectedFiles.filter(f => f.size <= maxSize)
      },
    sendDocument() {
      const userToken = getToken()
      const header = {
        'Content-Type': 'multipart/form-dataitem',
        Authorization: `Bearer ${userToken}`,
      }
      const formData = new FormData()
      if (typeof this.file[0] !== 'undefined') {
      formData.append('file', this.file[0], this.file[0].name)
      formData.append('document_material_request_id', this.materialRequestId)
      formData.append('time', moment())
    axios
      .post(`${process.env.VUE_APP_API_URL}${process.env.VUE_APP_API_CREATE_DOCUMENT}`, formData, { headers: header })
      .then(async response => {
        if (response.data.success === true) {
            this.$refs.refInvoiceListTable.refresh()
            this.$refs.refInvoiceListTableConfirmed.refresh()
            this.$refs.refInvoiceListTableUnconfirmed.refresh()
            this.$refs.uploadFile.reset()
      axios
        .get(
          `${process.env.VUE_APP_API_URL}${process.env.VUE_APP_API_GET_DOCUMENTS}mr/${this.materialRequestId}`,
          { headers: header },
        )
        .then(response2 => {
          if (response2.data.success === true) {
            if (response2.data.data) {
              this.documentsList.splice(0, this.documentsList.length)
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: "Documents loaded successfully",
                  icon: "CheckIcon",
                  variant: "success",
                },
              })
              response2.data.data.map(value => {
                this.documentsList.push(value)
              })
            }
          } else {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: "Unable to load documents. Please try again.",
                icon: "AlertTriangleIcon",
                variant: "danger",
              },
            })
          }
        })
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Purchase request confirmed successfully',
              icon: 'CheckIcon',
              variant: 'success',
            },
          })
        } else {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Unable to confirm the purchase request. Please try again.',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
        }
        })
      } else {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Select a document before uploading.',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.per-page-selector {
  width: 90px
}
.btable {
  width: 100%;
  max-width: 100%;
  min-height: 400px; /* Set your desired height */
  overflow-x: auto !important;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}
.invoice-list-card {
  width: 100%;
  max-width: 100%;
  min-width: 0;
  overflow: hidden;
}
.invoice-list-card ::v-deep .tabs,
.invoice-list-card ::v-deep .tab-content,
.invoice-list-card ::v-deep .tab-pane {
  max-width: 100%;
  min-width: 0;
}
.fixed-height-table {
  display: block;
  width: 100%;
  max-width: 100%;
  min-width: 0;
  overflow-x: auto;
  overscroll-behavior-x: contain;
  scrollbar-gutter: stable;
}
.invoice-table {
  margin-bottom: 0;
}
.invoice-table ::v-deep table {
  width: 100%;
  min-width: 70rem;
}
.invoice-table ::v-deep thead th {
  position: sticky;
  top: 0;
  z-index: 2;
  border-top: 0;
  white-space: nowrap;
}
.invoice-table ::v-deep tbody tr {
  transition: background-color 180ms ease;
}
.invoice-loading-state {
  display: flex;
  min-height: 12rem;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 0.35rem;
  color: #5e5873;
  text-align: center;
}
.invoice-loading-state small {
  color: #82868b;
}
.invoice-loading-indicator {
  position: relative;
  display: grid;
  width: 3.5rem;
  height: 3.5rem;
  margin-bottom: 0.35rem;
  place-items: center;
}
.invoice-loading-indicator .spinner-border {
  width: 2.15rem;
  height: 2.15rem;
}
.invoice-loading-pulse {
  position: absolute;
  inset: 0;
  border: 1px solid rgba(115, 103, 240, 0.4);
  border-radius: 50%;
  animation: invoice-loading-pulse 1.4s ease-out infinite;
}
@keyframes invoice-loading-pulse {
  0% {
    opacity: 0.8;
    transform: scale(0.55);
  }
  100% {
    opacity: 0;
    transform: scale(1);
  }
}
.invoice-table ::v-deep .invoice-action-toggle {
  width: 2.25rem;
  height: 2.25rem;
  padding: 0;
  border-radius: 50%;
}
.invoice-table ::v-deep thead th:last-child,
.invoice-table ::v-deep tbody td:last-child {
  position: sticky;
  right: 0;
  z-index: 1;
  background: #fff;
  box-shadow: -0.4rem 0 0.75rem -0.75rem rgba(34, 41, 47, 0.45);
}
.invoice-table ::v-deep thead th:last-child {
  z-index: 3;
  background: #f3f2f7;
}
.invoice-table-footer {
  padding-top: 1rem;
}
.invoice-table-summary {
  min-width: 0;
  gap: 0.65rem;
}
.invoice-table-legend {
  display: inline-flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 0.25rem;
  min-width: 0;
}
.missing-files-flag {
  display: inline-flex;
  align-items: center;
  gap: 0.3rem;
  margin-top: 0.35rem;
  padding: 0.22rem 0.5rem;
  border: 1px solid rgba(234, 84, 85, 0.3);
  border-radius: 999px;
  background: rgba(234, 84, 85, 0.1);
  color: #d83a3b;
  font-size: 0.72rem;
  font-weight: 600;
  line-height: 1;
  white-space: nowrap;
}
.missing-files-flag strong {
  display: inline-flex;
  min-width: 1rem;
  height: 1rem;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: #d83a3b;
  color: #fff;
  font-size: 0.64rem;
}
.edit-invoice-actions {
  display: flex;
  justify-content: flex-end;
  gap: 0.75rem;
  padding-top: 0.25rem;
}
.invoice-list-card ::v-deep .nav-tabs {
  max-width: 100%;
}
.b-calendar {
  z-index: 1050!important; /* Adjust the z-index to be higher than the modal */
}
.hidden {
  display: none;
}
.pad-down-2{
  padding-bottom: 20px;
}

@media (max-width: 767.98px) {
  .btable {
    min-height: 0;
    overflow-x: visible !important;
  }

  .fixed-height-table {
    overflow-x: visible;
    scrollbar-gutter: auto;
  }

  .invoice-table ::v-deep table {
    min-width: 0;
  }

  .invoice-list-card ::v-deep .nav-tabs {
    flex-wrap: nowrap;
    overflow-x: auto;
    overflow-y: hidden;
    -webkit-overflow-scrolling: touch;
  }

  .invoice-list-card ::v-deep .nav-tabs .nav-link {
    white-space: nowrap;
  }

  .invoice-table-footer {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }

  .invoice-table-summary {
    align-items: flex-start !important;
    flex-direction: column;
    text-align: left;
  }

  .invoice-table-legend {
    font-size: 0.8rem;
  }

  .invoice-table ::v-deep .b-table-stacked-md > tbody > tr {
    margin: 0.75rem;
    border: 1px solid rgba(34, 41, 47, 0.1);
    border-radius: 0.5rem;
    box-shadow: 0 0.15rem 0.6rem rgba(34, 41, 47, 0.06);
  }

  .invoice-table ::v-deep .b-table-stacked-md > tbody > tr > td {
    padding: 0.65rem 1rem;
    border-top: 0;
  }

  .invoice-table ::v-deep thead th:last-child,
  .invoice-table ::v-deep tbody td:last-child {
    position: static;
    box-shadow: none;
  }

  .invoice-table ::v-deep .dropdown-menu {
    max-width: calc(100vw - 3rem);
  }
}

@media (max-width: 399.98px) {
  .edit-invoice-actions {
    flex-direction: column-reverse;
  }

  .edit-invoice-actions .btn {
    width: 100%;
  }

  .invoice-table-footer {
    margin-right: 0.75rem !important;
    margin-left: 0.75rem !important;
  }

  .invoice-table-footer ::v-deep .pagination {
    flex-wrap: wrap;
    justify-content: center;
  }
}

@media (min-width: 1600px) {
  .invoice-table ::v-deep table {
    min-width: 100%;
  }

  .invoice-table ::v-deep th,
  .invoice-table ::v-deep td {
    padding-right: 1.25rem;
    padding-left: 1.25rem;
  }
}

@media (prefers-reduced-motion: reduce) {
  .invoice-table ::v-deep tbody tr {
    transition: none;
  }

  .invoice-loading-pulse {
    animation: none;
  }
}
</style>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";

.dark-layout {
  .invoice-table {
    thead th:last-child {
      background: #343d55;
    }

    tbody td:last-child {
      background: #283046;
    }
  }
}
</style>
